import axios from "axios";

export default {
    confirmImport: async (companyId, importSessionId, includedList, updateDataFromCompanyRegister) => {
        return await axios.post('/import/confirm', {
            account_id: companyId,
            import_session_id: importSessionId,
            included_ids: includedList,
            update_data_from_company_register: updateDataFromCompanyRegister
        })
    },
    cancelImport: async (importSessionId) => {
        return await axios.post('/import/cancel', {
            import_session_id: importSessionId,
        })
    },
    async getImportResult(importSessionId){
        const { data } = await axios.get('/import_result/', { params: { import_session_id: importSessionId }})
        return data
    },
    async getImportSession(importSessionId, includePreview, includeMapping) {
        let params = {
            include_preview: includePreview ? 1 : 0,
            include_mapping: includeMapping ? 1 : 0
        }
        const { data } = await axios.get(`/import_session/${importSessionId}`, { params })
        return data
    },
    async saveImportSession(payload) {
        const { data } = await axios.post(`/import_session/${payload.id ? payload.id : ''}`, payload)
        return data
    },
    async getLastExcelImportData(companyId) {
        const { data } = await axios.get(`/import/${companyId}/last_excel_import`)
        return data
    },
    async saveImportSettings(payload) {
        const { data } = await axios.post(`/import/${payload.id ? payload.id : ''}/settings`, payload)
        return data
    }
}